import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { SparkleEffect } from '../components/SparkleEffect';
import { GlitterHeart } from '../components/GlitterHeart';
import { ArrowRightIcon } from 'lucide-react';
export function FreeResourcesPage() {
  return <div className="min-h-screen bg-white pt-24 pb-24" data-id="element-542">
      {/* Hero */}
      <section className="relative py-20 text-center overflow-hidden bg-gradient-to-b from-blush-50 to-white" data-id="element-543">
        <SparkleEffect count={80} data-id="element-544" />
        <div className="max-w-3xl mx-auto px-4 relative z-10" data-id="element-545">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="font-heading text-5xl md:text-6xl font-bold text-plum-700 mb-6" data-id="element-546">
            Trippin' Through <span className="text-cta-500" data-id="element-547">Guidance</span>
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-xl text-plum-500 font-medium" data-id="element-548">
            Tools, support, and a gentle reminder that you don't have to figure
            it all out alone.
          </motion.p>
        </div>
      </section>

      {/* FREE RESOURCES SECTION */}
      <section className="py-16 bg-white relative overflow-hidden" data-id="element-549">
        <SparkleEffect count={60} data-id="element-550" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-551">
          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-552">
            <h2 className="font-heading text-4xl md:text-5xl font-bold text-plum-700 mb-6" data-id="element-553">
              Free Resources & Reset
            </h2>
            <p className="text-lg text-plum-600 font-medium leading-relaxed" data-id="element-554">
              I've been through some really hard things in life—and I know what
              it feels like to feel stuck, overwhelmed, or alone. If that's
              where you are right now, please know this:{' '}
              <strong className="text-plum-800" data-id="element-555">
                you matter, and you don't have to figure it all out by yourself.
              </strong>
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16" data-id="element-556">
            {/* Card 1 */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="bg-blush-50 rounded-3xl p-8 border border-blush-100 shadow-sm" data-id="element-557">
              <div className="text-3xl mb-4" data-id="element-558">🧘‍♀️</div>
              <h3 className="font-heading text-2xl font-bold text-plum-700 mb-4" data-id="element-559">
                Things You Can Do Right Now
              </h3>
              <ul className="space-y-3 text-plum-600 font-medium" data-id="element-560">
                <li className="flex items-start gap-2" data-id="element-561">
                  <span className="text-cta-500 mt-1" data-id="element-562">•</span> Take a deep
                  breath (seriously—slow it down)
                </li>
                <li className="flex items-start gap-2" data-id="element-563">
                  <span className="text-cta-500 mt-1" data-id="element-564">•</span> Drink some water
                </li>
                <li className="flex items-start gap-2" data-id="element-565">
                  <span className="text-cta-500 mt-1" data-id="element-566">•</span> Step outside for
                  a few minutes
                </li>
                <li className="flex items-start gap-2" data-id="element-567">
                  <span className="text-cta-500 mt-1" data-id="element-568">•</span> Text someone you
                  trust
                </li>
                <li className="flex items-start gap-2" data-id="element-569">
                  <span className="text-cta-500 mt-1" data-id="element-570">•</span> Put on music that
                  grounds you
                </li>
              </ul>
            </motion.div>

            {/* Card 2 */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="bg-lavender-50 rounded-3xl p-8 border border-lavender-100 shadow-sm" data-id="element-571">
              <div className="text-3xl mb-4" data-id="element-572">📓</div>
              <h3 className="font-heading text-2xl font-bold text-plum-700 mb-4" data-id="element-573">
                Quick Reset Questions
              </h3>
              <ul className="space-y-3 text-plum-600 font-medium" data-id="element-574">
                <li className="flex items-start gap-2" data-id="element-575">
                  <span className="text-cta-500 mt-1" data-id="element-576">•</span> What am I feeling
                  right now?
                </li>
                <li className="flex items-start gap-2" data-id="element-577">
                  <span className="text-cta-500 mt-1" data-id="element-578">•</span> What do I
                  actually need today?
                </li>
                <li className="flex items-start gap-2" data-id="element-579">
                  <span className="text-cta-500 mt-1" data-id="element-580">•</span> What's one small
                  thing I can do?
                </li>
              </ul>
            </motion.div>

            {/* Card 3 */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="bg-sky-50 rounded-3xl p-8 border border-sky-100 shadow-sm" data-id="element-581">
              <div className="text-3xl mb-4" data-id="element-582">💖</div>
              <h3 className="font-heading text-2xl font-bold text-plum-700 mb-4" data-id="element-583">
                Body + Self-Love
              </h3>
              <ul className="space-y-3 text-plum-600 font-medium" data-id="element-584">
                <li className="flex items-start gap-2" data-id="element-585">
                  <span className="text-cta-500 mt-1" data-id="element-586">•</span> You don't have to
                  hate your body to change your life
                </li>
                <li className="flex items-start gap-2" data-id="element-587">
                  <span className="text-cta-500 mt-1" data-id="element-588">•</span> Rest is
                  productive
                </li>
                <li className="flex items-start gap-2" data-id="element-589">
                  <span className="text-cta-500 mt-1" data-id="element-590">•</span> Taking care of
                  yourself is not selfish
                </li>
              </ul>
            </motion.div>
          </div>

          {/* Travel & CTA row */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-591">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="bg-white border-2 border-blush-200 rounded-3xl p-8 shadow-md text-center flex flex-col justify-center items-center" data-id="element-592">
              <div className="text-4xl mb-4" data-id="element-593">✈️</div>
              <p className="text-plum-600 font-medium mb-6" data-id="element-594">
                Sometimes healing looks like a break, a reset, or even a change
                of scenery. If you've been needing that, I can help you find
                something that fits your budget.
              </p>
              <Link to="/travel" className="inline-flex items-center gap-2 text-cta-500 font-bold hover:text-cta-600 transition-colors" data-id="element-595">
                Let's Plan Your Escape <ArrowRightIcon className="w-4 h-4" data-id="element-596" />
              </Link>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="bg-gradient-to-br from-plum-800 to-plum-900 rounded-3xl p-8 shadow-xl text-center flex flex-col justify-center items-center text-white" data-id="element-597">
              <div className="text-4xl mb-4" data-id="element-598">💬</div>
              <p className="text-plum-100 font-medium mb-8 text-lg" data-id="element-599">
                If you're ready to start rebuilding, I'm here for you.
              </p>
              <Link to="/coaching" className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full bg-cta-500 text-white font-bold text-lg hover:bg-cta-600 transition-all shadow-lg hover:-translate-y-1" data-id="element-600">
                <GlitterHeart size={20} variant="light" data-id="element-601" />
                Start Your Reset
              </Link>
            </motion.div>
          </div>
        </div>
      </section>

      {/* MENTAL HEALTH SUPPORT */}
      <section className="py-16 bg-plum-50 border-y border-plum-100 relative overflow-hidden" data-id="element-602">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-603">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} data-id="element-604">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-white rounded-full shadow-sm mb-6 text-3xl" data-id="element-605">
              💖
            </div>
            <h2 className="font-heading text-3xl font-bold text-plum-800 mb-4" data-id="element-606">
              Mental Health Support
            </h2>
            <p className="text-plum-600 font-medium mb-10 max-w-2xl mx-auto" data-id="element-607">
              If you're struggling, please don't go through it alone. There are
              people who care and want to help—right now.{' '}
              <strong className="text-plum-800" data-id="element-608">
                If you are in immediate danger, please call 911.
              </strong>
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-left" data-id="element-609">
              <div className="bg-white p-8 rounded-3xl shadow-sm border border-plum-100" data-id="element-610">
                <h3 className="font-bold text-plum-800 mb-2 flex items-center gap-2 text-lg" data-id="element-611">
                  <span className="text-cta-500 text-xl" data-id="element-612">📞</span> 988 Suicide &
                  Crisis Lifeline
                </h3>
                <p className="text-plum-600 text-sm mb-4" data-id="element-613">
                  Available 24/7, free and confidential.
                </p>
                <div className="space-y-3" data-id="element-614">
                  <a href="tel:988" className="inline-block bg-plum-100 text-plum-800 px-4 py-2 rounded-lg font-bold hover:bg-plum-200 transition-colors" data-id="element-615">
                    Call or Text 988
                  </a>
                  <a href="https://988lifeline.org" target="_blank" rel="noopener noreferrer" className="inline-block bg-plum-100 text-plum-800 px-4 py-2 rounded-lg font-bold hover:bg-plum-200 transition-colors ml-2" data-id="element-616">
                    Chat online: 988lifeline.org
                  </a>
                </div>
              </div>

              <div className="bg-white p-8 rounded-3xl shadow-sm border border-plum-100" data-id="element-617">
                <h3 className="font-bold text-plum-800 mb-4 flex items-center gap-2 text-lg" data-id="element-618">
                  <span className="text-cta-500 text-xl" data-id="element-619">🧠</span> Additional
                  Support
                </h3>
                <div className="space-y-5" data-id="element-620">
                  <div data-id="element-621">
                    <p className="font-bold text-plum-700 mb-1" data-id="element-622">
                      Crisis Text Line
                    </p>
                    <a href="sms:741741" className="text-cta-600 font-bold hover:underline" data-id="element-623">
                      Text HOME to 741741 (U.S.)
                    </a>
                  </div>
                  <div data-id="element-624">
                    <p className="font-bold text-plum-700 mb-1" data-id="element-625">
                      SAMHSA Helpline
                    </p>
                    <div className="flex flex-wrap gap-3" data-id="element-626">
                      <a href="tel:1-800-662-4357" className="text-cta-600 font-bold hover:underline" data-id="element-627">
                        1-800-662-HELP (4357)
                      </a>
                      <span className="text-plum-300" data-id="element-628">•</span>
                      <a href="https://www.samhsa.gov" target="_blank" rel="noopener noreferrer" className="text-cta-600 font-bold hover:underline" data-id="element-629">
                        samhsa.gov
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-10 bg-white/80 backdrop-blur-sm rounded-3xl p-8 md:p-10 border border-blush-200 shadow-sm max-w-2xl mx-auto text-center" data-id="element-630">
              <GlitterHeart size={28} className="mx-auto mb-4" data-id="element-631" />
              <p className="text-plum-700 font-medium leading-relaxed mb-4" data-id="element-632">
                If you're dealing with anxiety, depression, or anything that
                just feels too heavy—please don't try to carry it alone.
              </p>
              <p className="text-plum-800 font-bold text-lg mb-4" data-id="element-633">
                Talk to your doctor. Talk to someone.
              </p>
              <p className="text-plum-700 font-medium leading-relaxed mb-4" data-id="element-634">
                There's only so far you can go by yourself sometimes—and that's
                okay. Getting support isn't weakness, it's part of healing.
              </p>
              <p className="text-cta-500 font-bold text-lg italic" data-id="element-635">
                Healing changes everything, and you deserve to experience that.
                💖
              </p>
            </div>
          </motion.div>
        </div>
      </section>
    </div>;
}